import { Environment, getEnv } from 'app/utils/getEnv';

/**
 * Attempts to build the base URL used for courses for our back-end.
 * 
 * @param {string} environment - The environment to build the path for.
 * @returns {string}
 */
export function getCourseBasePath( environment ) {
    switch ( environment ) {
        case Environment.LOCAL: {
            return 'https://qa.biwlearning-hoya.com/lms/';
        }
        case Environment.QA: {
            return 'https://qa.biwlearning-hoya.com/lms/';
        }
        case Environment.PPRD: {
            return 'https://pprd.biwlearning-hoya.com/lms/';
        }
        case Environment.PROD: {
            return 'https://biwlearning-hoya.com/lms/';
        }
        default: {
            return 'https://qa.biwlearning-hoya.com/lms/';
        }
    }
}

/**
 * Attempts to build the URL to access a single course. The environment will
 * used in the path will attempt to match the environment the code is running
 * in. A path should be provided that leads to the desired course and course
 * content.
 * 
 * @param {string} path - The path of the target course. This will be placed at the end of the 
 * @returns {string}
 */
export const buildCoursePath = ( path ) => {
    const env = getEnv( window.location.hostname );
    const basePath = getCourseBasePath( env );
    return ( path ) ? `${ basePath }${ ( path.charAt( 0 ) === '/' ) ? path.substr( 1 ) : path }` : basePath;
};
